import { startTransition, useEffect, useState } from 'react';
import { type WithTestId } from '@pkgs/components/types/types';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { type BigDecimalRangeDto } from '@ev-tech/search-modules-api';

import { type FilterDropdownProps } from './FilterDropdown.types';
import { ConstructionYearInput } from '../RangeInputs/ConstructionYearInput';
import { RangeDropdown } from '../RangeDropdown/RangeDropdown';
import { formatRangeLabel } from '../../utils/stringUtils';
import { validateRangeValues } from '../../utils/numberFormatters';
import { useAppContext } from '../../hooks/useAppContext';

export type ConstructionFilterDropdownProps = WithTestId<FilterDropdownProps>;

export const ConstructionFilterDropdown = ({ className, 'data-testid': dataTestId }: ConstructionFilterDropdownProps) => {
  const {
    t,
    options: { language },
  } = useAppContext();

  const constructionYear = useSearchStore((state) => state.constructionYear);
  const setConstructionYear = useSearchStore((state) => state.setConstructionYear);

  const [range, setRange] = useState<BigDecimalRangeDto | undefined>(constructionYear ? validateRangeValues(constructionYear) : undefined);

  const constructionYearLabel = t('search.searchbar.advFilter.constructionYear');

  useEffect(() => {
    setRange(constructionYear ? validateRangeValues(constructionYear) : undefined);
  }, [constructionYear]);

  return (
    <RangeDropdown
      className={className}
      range={range}
      maxWidth={212}
      label={constructionYearLabel}
      value={constructionYear ? formatRangeLabel({ value: constructionYear, unit: '', language, shouldFormatNumbers: false }) : ''}
      onDone={() => {
        if (range) startTransition(() => setConstructionYear(range));
      }}
      onReset={() => {
        setRange(undefined);
        if (constructionYear !== undefined) {
          startTransition(() => setConstructionYear(undefined));
        }
      }}
      data-testid={dataTestId ? `${dataTestId}_dropdown` : 'search-components_construction-year-filter_dropdown'}
    >
      <ConstructionYearInput hasLabelHidden={true} defaultRange={range} onChange={setRange} data-testid={dataTestId} />
    </RangeDropdown>
  );
};
